import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { externalLinks } from '../data/mock';
import { ExternalLink, MousePointer, Calendar, CreditCard, MessageSquare } from 'lucide-react';

const BookingFunnel = () => {
  const { t } = useLanguage();

  const steps = [
    { num: 1, icon: <MousePointer size={24} />, text: t('step1') },
    { num: 2, icon: <Calendar size={24} />, text: t('step2') },
    { num: 3, icon: <CreditCard size={24} />, text: t('step3') },
    { num: 4, icon: <MessageSquare size={24} />, text: t('step4') }
  ];

  return (
    <section className="bg-[#121212] py-16 md:py-24 animate-fade-in">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-12">
          {t('bookingTitle')}
        </h2>
        
        {/* Steps */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mb-12">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="flex flex-col items-center text-center p-6 bg-black border border-white/10">
                <div className="w-10 h-10 flex items-center justify-center bg-[#00FFD1] text-black font-bold text-lg mb-4">
                  {step.num}
                </div>
                <div className="text-[#00FFD1] mb-3">{step.icon}</div>
                <span className="text-white/90 text-sm md:text-base">{step.text}</span>
              </div>
              
              {/* Arrow connector (not on last item) */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-3 transform -translate-y-1/2 text-white/30">
                  →
                </div>
              )}
            </div>
          ))}
        </div>
        
        {/* CTA */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={externalLinks.naverStore}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-4 bg-[#00FFD1] text-black font-semibold text-lg transition-all duration-300 hover:bg-[#00FFD1]/10 hover:text-[#00FFD1]"
            style={{ borderRadius: 0 }}
          >
            {t('naverReserve')}
            <ExternalLink size={18} />
          </a>
          <a
            href={externalLinks.kakao}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-4 bg-white/10 text-white font-semibold text-lg transition-all duration-300 hover:bg-white hover:text-black"
            style={{ borderRadius: 0 }}
          >
            {t('inquiry')}
          </a>
        </div>
      </div>
    </section>
  );
};

export default BookingFunnel;